<template>
  <div class="completion-page">
    <v-card
      width="440"
      class="completion-card">
      <v-card-title>Opening TastingIQ</v-card-title>
      <v-card-text>
        <div
          v-if="!error"
          role="status"
          aria-live="polite">
          <v-progress-circular
            indeterminate
            color="primary"
            class="mr-2"
          />
          {{ status }}
        </div>
        <div
          v-else
          class="error-message"
          role="alert">
          <p>{{ error }}</p>
          <p v-if="username">
            Username: <strong>{{ username }}</strong>
          </p>
          <v-btn
            :to="loginDestination"
            color="primary"
            @click="rememberUsernameForLogin">
            Sign In with Your New Password
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'
import { TokenService } from '../services/storage.service'

export default {
  data () {
    return {
      error: null,
      status: 'Signing you in and opening Event Request...',
      username: window.sessionStorage.getItem('tastingiq_login_username') || ''
    }
  },

  computed: {
    loginDestination () {
      return {
        path: '/login',
        query: {
          return: '/event-request'
        }
      }
    }
  },

  created () {
    this.completeLogin()
  },

  methods: {
    rememberUsernameForLogin () {
      if (this.username) {
        window.sessionStorage.setItem('tastingiq_login_username', this.username)
      }
    },

    async completeLogin () {
      const storageKey = 'tastingiq_one_time_login_handoff'
      const earlyToken = window.__TASTINGIQ_ONE_TIME_TOKEN__
      const fragment = new URLSearchParams(window.location.hash.slice(1))
      const handoffToken = earlyToken && earlyToken.purpose === 'login_handoff'
        ? earlyToken.token
        : (fragment.get('token') || window.sessionStorage.getItem(storageKey) || '')
      if (handoffToken) window.sessionStorage.setItem(storageKey, handoffToken)
      delete window.__TASTINGIQ_ONE_TIME_TOKEN__
      window.history.replaceState(null, '', window.location.pathname + window.location.search)

      if (!handoffToken) {
        this.error = 'The automatic sign-in link is incomplete. Sign in with the username and password you just created.'
        return
      }

      TokenService.clearLogin({ preserveSetupUsername: true })
      this.$store.commit('setUserProfile', null)

      try {
        await this.$store.dispatch('get_config')
        const result = await axios.post(
          this.$store.state.apiRoot + 'auth/login-handoff',
          { token: handoffToken },
          { headers: { 'Content-Type': 'application/json' } }
        )
        const response = result.data
        if (response.status !== 'success') {
          throw new Error(response.message || 'Automatic sign-in could not be completed.')
        }

        window.sessionStorage.removeItem(storageKey)
        this.username = response.username || this.username
        if (this.username) {
          window.sessionStorage.setItem('tastingiq_login_username', this.username)
        }
        this.$store.commit('setLoginCredentials', {
          code: response.code,
          accessKey: response.access_key,
          type: response.type,
          username: response.username,
          user: response.user || null
        })
        TokenService.saveUsername(response.username)

        await this.$store.dispatch('set_client', {
          access_key: response.access_key,
          client_code: response.code
        })
        TokenService.setSeenLoginPage()
        await this.$router.replace('/event-request')
        window.sessionStorage.removeItem('tastingiq_login_username')
      } catch (error) {
        if (error && error.response && error.response.status === 400) {
          window.sessionStorage.removeItem(storageKey)
        }
        TokenService.clearLogin({ preserveSetupUsername: true })
        this.$store.commit('setUserProfile', null)
        this.error = error && error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : ((error && error.message) || 'Automatic sign-in could not be completed. Sign in with your new password.')
      }
    }
  }
}
</script>

<style scoped>
.completion-page {
  align-items: flex-start;
  background: #f4f3fb;
  display: flex;
  justify-content: center;
  min-height: 100vh;
  padding-top: 8vh;
}

.completion-card {
  padding: 16px;
}

.error-message {
  color: #b71c1c;
}
</style>
